module.exports = __webpack_public_path__ + "img/registered-logo-ed.1d2e1770.png";